// Cookie Consent — สถานะการรับทราบการใช้คุกกี้ (แก้ที่เดียว มีผลทุกจุดที่ import)
//
// เว็บนี้ใช้แต่คุกกี้ที่ "จำเป็นอย่างยิ่ง" (access_token/XSRF/session) และคุกกี้เชิงการทำงาน
// ที่ผู้ใช้ร้องขอเอง (locale = เลือกภาษาเอง, rememberMe = ติ๊ก checkbox เอง)
// — ไม่มีคุกกี้ analytics/marketing (ตรวจแล้วไม่พบ gtag/GA/pixel)
//
// ตามหลัก PDPA/PDPC: คุกกี้จำเป็น + ที่ผู้ใช้ร้องขอ = ได้รับยกเว้น ไม่ต้องขอ consent
// → banner จึงเป็นแบบ "แจ้งให้ทราบ" (informational) ไม่ใช่การขอเลือกเปิด-ปิด
// (ถ้าอนาคตเพิ่มคุกกี้ analytics/marketing ต้องกลับมาทำ opt-in consent จริง)
//
// การเก็บ "การรับทราบ" ลง localStorage ถือเป็นฟังก์ชันที่จำเป็น → ทำได้ (ไม่เก็บข้อมูล sensitive)

const STORAGE_KEY = 'dga_cookie_consent';

// เพิ่มเลขนี้เมื่อ "นโยบายคุกกี้" เปลี่ยน → ระบบจะแสดง banner แจ้งเตือนใหม่อัตโนมัติ
// (v2 = เปลี่ยนจากรูปแบบเลือกหมวด → แบบแจ้งให้ทราบ)
export const CONSENT_VERSION = 2;

// event ที่ dispatch เมื่อผู้ใช้รับทราบ (เผื่อโมดูลอื่น subscribe ในอนาคต)
export const CONSENT_CHANGED_EVENT = 'dga-cookie-consent-changed';

function readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

// คืนค่า record ที่บันทึกไว้ หรือ null ถ้ายังไม่เคยรับทราบ
// รูปแบบ: { version, timestamp, acknowledged: true }
export function getConsent() {
  return readRaw();
}

// record ใช้ได้จริงเมื่อ version ตรงปัจจุบัน และ acknowledged = true
export function isValidConsent(record) {
  return !!(record && record.version === CONSENT_VERSION && record.acknowledged === true);
}

// true = เคยรับทราบแล้วและยังใช้ได้ (ไม่ต้องแสดง banner)
export function hasDecision() {
  return isValidConsent(readRaw());
}

// บันทึกการรับทราบการใช้คุกกี้
export function acknowledgeConsent() {
  const record = {
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
    acknowledged: true,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch (_) {
    // localStorage ปิด/เต็ม → ยังคืน record ให้ UI ปิด banner ในเซสชันนี้ได้
  }
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: record }));
  } catch (_) {
    /* no-op */
  }
  return record;
}

// ล้างการรับทราบ (เช่น ตอนทดสอบ)
export function resetConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* no-op */
  }
}
